import { RestClient } from "@infrastructure/clients/http/clients/base/rest.client";

export interface ShortPollingOptions {
  onMessage: (data: any) => void;
  onError?: (error: Error) => void;
  onClose?: () => void;
  interval?: number;
}

export abstract class ShortPollingClient extends RestClient {
  abstract baseUrl: string;
  private pollingInterval: NodeJS.Timeout | null = null;
  private isPolling = false;

  startPolling(endpoint: string, options: ShortPollingOptions): () => void {
    const interval = options.interval || 5000;
    this.isPolling = true;

    const poll = async () => {
      if (!this.isPolling) return;

      try {
        const result = await this.request("GET", endpoint);
        options.onMessage(result.data);
      } catch (error) {
        options.onError?.(error as Error);
      }
    };

    // Первый запрос сразу
    poll();

    // Затем периодически
    this.pollingInterval = setInterval(poll, interval);

    return () => {
      this.stopPolling();
    };
  }

  stopPolling(): void {
    this.isPolling = false;
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  isPollingActive(): boolean {
    return this.isPolling;
  }
}

